module.exports = __webpack_public_path__ + "img/video5.3c490b45.jpg";